import React from "react"
import CircularProgress from "material-ui/CircularProgress"
import UserStore from "../../../stores/UserStore"
import SummaryForSelfService from "./user-details-summary-for-self-service/SummaryForSelfService"
import UserDetailsData from "./UserDetailsData"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import autobind from "class-autobind"
import * as userActions from "../../../actions/UserActions"
import { IUserDocument, ELoggedInUserType, IHolidayInstanceForPunch } from "../../../models"
import strings from "../../../localization/strings"
interface IProps {
	params: { subpage: string }
}
interface IState {
	showProgress: boolean
	currentUser: IUserDocument
	userStatsFaceSpaces: number
	userStatsRecords: number
	holidays: IHolidayInstanceForPunch[]
	reloadTimecard: boolean
}

export default class EmployeeSelfDetails extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			showProgress: true,
			currentUser: UserStore.getCurrentUserDetail() || null,
			userStatsFaceSpaces: UserStore.getUserStatsFaceSpaces(),
			userStatsRecords: UserStore.getUserStatsRecords(),
			holidays: [],
			reloadTimecard: false,
		}
		autobind(this)
	}

	componentDidMount() {
		document.title = `${strings.Self_Service} | ${strings.Findd_Grandd_Central}`
		UserStore.on("change", this.changeEvent)
		UserStore.on("change_reload_self_service_leave_dashboard", this.reloadSelfServiceChangeEvent)
		setTimeout(() => {
			userActions.loadUserDetails(AuthenticationStore.getLoggedInUser().Id)
			userActions.getAllHolidays(AuthenticationStore.getLoggedInUser().Id)
		}, 0)
	}

	componentWillUnmount() {
		UserStore.clearCurrentUserDetail()
		UserStore.removeListener("change", this.changeEvent)
		UserStore.removeListener("change_reload_self_service_leave_dashboard", this.reloadSelfServiceChangeEvent)
	}

	reloadSelfServiceChangeEvent() {
		setTimeout(() => userActions.loadUserDetails(AuthenticationStore.getLoggedInUser().Id, false), 0)
	}

	changeEvent() {
		this.setState({
			showProgress: UserStore.isFetchingUserDetail(),
			currentUser: UserStore.getCurrentUserDetail(),
			userStatsFaceSpaces: UserStore.getUserStatsFaceSpaces(),
			userStatsRecords: UserStore.getUserStatsRecords(),
			holidays: UserStore.getHolidays()
		})
	}

	render() {
		return (
			<div className="page-container UserDetails">
				{this.state.showProgress ?
					<div className="spinner" style={{ display: "flex", flex: "1 1 100%", placeContent: "center", height: "75vh", paddingTop: "12em" }}>
						<CircularProgress />
					</div> :
					<div className="user-details">
						<SummaryForSelfService
							user={this.state.currentUser}
							loggedInUserType={ELoggedInUserType.Employee}
							reloadTimecard={() => this.setState({ reloadTimecard: true }, () => this.setState({ reloadTimecard: false }))}
						/>
						<UserDetailsData
							user={this.state.currentUser}
							userId={AuthenticationStore.getLoggedInUser().Id}
							readonly
							readonlyForHierarchy
							editDevicePermission={false}
							addDevicePermission={false}
							deleteDevicePermission={false}
							timecardReadOnly
							timecardApprovals
							tabActive={this.props.params.subpage}
							loggedInUserType={ELoggedInUserType.Employee}
							readonlyForIndependentPermission
							readonlySchedule
							holidays={this.state.holidays}
							reloadTimecard={this.state.reloadTimecard}
						/>
					</div>
				}
			</div>
		)
	}
}
